import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { dataSyncLogQueryParamsSchema } from '~/data/dataSyncJob';

import { DataSyncLogs } from '~/modules/dataSyncJobs/logs/DataSyncLogs';

import { stripUnknownSearchParams } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

export const Route = createFileRoute('/(main)/settings/admin/data-sync/logs/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/admin/data-sync/logs/',
  }),
  component: DataSyncLogs,
  search: {
    middlewares: [
      stripSearchParams(dataSyncLogQueryParamsSchema.parse({})),
      stripUnknownSearchParams(dataSyncLogQueryParamsSchema.parse({})),
    ],
  },
  validateSearch: dataSyncLogQueryParamsSchema,
});

export const DATA_SYNC_LOGS = buildRouteExport({
  Route,
});
